import { Components, Theme } from "@mui/material";

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    blue1: true;
    blue2: true;
    orange1: true;
    orange2: true;
    orange3: true;
    brown: true;
    yellow: true;
    green: true;
    teal: true;
    purple1: true;
    purple2: true;
    purple3: true;
    pink: true;
    grey: true;
  }
}

export const MuiChip: Components<Omit<Theme, "MuiChip">>["MuiChip"] = {
  defaultProps: {
    variant: "outlined",
    size: "small",
  },
  styleOverrides: {
    root: {
      borderRadius: 4,
      fontWeight: 500,
      fontSize: 12,
      lineHeight: "18px",
      height: "auto",
      padding: "1px 6px",
    },
    label: {
      padding: 0,
    },
    outlined: {
      borderWidth: 1,
      borderStyle: "solid",
    },
    filled: {
      border: "none",
      borderRadius: 88,
    },
    sizeMedium: {
      padding: "4px 8px",
    },
    colorSuccess: ({ theme: { palette } }) => ({
      // TODO: this should be teal 75 but it's not in the palette
      // backgroundColor: palette.custom.teal[75],
      backgroundColor: "#DBF1EC",
      borderColor: palette.custom.teal[100],
      color: palette.custom.teal[600],
    }),
    colorWarning: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.orange[100],
      borderColor: palette.custom.orange[200],
      color: palette.custom.orange[800],
    }),
    colorDefault: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.grey[100],
      borderColor: palette.custom.grey[200],
      color: palette.custom.grey[800],
    }),
    colorError: ({ theme: { palette } }) => ({
      backgroundColor: palette.custom.red[50],
      borderColor: palette.custom.red[100],
      color: palette.custom.red[500],
    }),
  },
  variants: [
    {
      props: { color: "blue1" },
      style: ({ theme: { palette } }) => ({
        backgroundColor: palette.custom.blue[50],
        borderColor: palette.custom.blue[100],
        color: palette.custom.blue[600],
      }),
    },
    // TODO: use colors from palette
    {
      props: { color: "blue2" },
      style: () => ({
        backgroundColor: "#C6E0FF",
        borderColor: `#67ACFF`,
        color: "#065CC4",
      }),
    },
    {
      props: { color: "orange1" },
      style: () => ({
        backgroundColor: "#FEFAE3",
        borderColor: `#FFDEC0`,
        color: "#B54707",
      }),
    },
    {
      props: { color: "orange2" },
      style: ({ theme: { palette } }) => ({
        backgroundColor: palette.custom.orange[50],
        borderColor: palette.custom.orange[100],
        color: palette.custom.orange[800],
      }),
    },
    {
      props: { color: "orange3" },
      style: () => ({
        backgroundColor: "#F5E6B3",
        borderColor: `#F3C186`,
        color: "#DE8217",
      }),
    },
    {
      props: { color: "brown" },
      style: () => ({
        backgroundColor: "#EDD9CF",
        borderColor: `#D6AB97`,
        color: "#AE7054",
      }),
    },
    {
      props: { color: "yellow" },
      style: () => ({
        backgroundColor: "#FAF6A7",
        borderColor: `#F0E9AC`,
        color: "#A17400",
      }),
    },
    {
      props: { color: "green" },
      style: ({ theme: { palette } }) => ({
        backgroundColor: palette.custom.green[50],
        borderColor: palette.custom.green[100],
        color: palette.custom.green[800],
      }),
    },
    {
      props: { color: "teal" },
      style: () => ({
        backgroundColor: "#D6F7F3",
        borderColor: `#9DD3DA`,
        color: "#2B818D",
      }),
    },
    {
      props: { color: "purple1" },
      style: () => ({
        backgroundColor: "#F4F3FF",
        borderColor: `#DBD8FF`,
        color: "#5A25DD",
      }),
    },
    {
      props: { color: "purple2" },
      style: ({ theme: { palette } }) => ({
        backgroundColor: palette.custom.purple[50],
        borderColor: palette.custom.purple[100],
        color: palette.custom.purple[700],
      }),
    },
    {
      props: { color: "purple3" },
      style: () => ({
        backgroundColor: "#F3E4FF",
        borderColor: `#E3C2FE`,
        color: "#A66AD7",
      }),
    },
    {
      props: { color: "pink" },
      style: () => ({
        backgroundColor: "#FDF2FB",
        borderColor: `#F4CBE2`,
        color: "#C11574",
      }),
    },
    {
      props: { color: "grey" },
      style: ({ theme: { palette } }) => ({
        backgroundColor: palette.custom.grey[50],
        borderColor: palette.custom.grey[100],
        color: palette.custom.grey[800],
      }),
    },
  ],
};
